<p>Choose a lottery license and date range for your report. Only games with draw dates within the selected date range and
  associated with the chosen lottery license will be included in the report.</p>
@if (uiState === uiStateEnumForTemplate.ShowLoading) {
  <div class="text-center" data-testid="lottery-license-loading">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <form [formGroup]="lotteryLicenseFormGroup">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Lottery License</mat-label>
      <mat-select formControlName="lotteryLicense" data-testid="lottery-license-select">
        @for (license of lotteryLicenses; track license.Id) {
          <mat-option [value]="license" data-testid="lottery-license-option">#{{ license.LicenceNumber }}</mat-option>
        }
      </mat-select>
      <mat-error *ngIf="lotteryLicenseFormGroup.controls.lotteryLicense.errors &&
                        (lotteryLicenseFormGroup.controls.lotteryLicense.dirty ||
                         lotteryLicenseFormGroup.controls.lotteryLicense.touched)">
        Lottery License is required
      </mat-error>
    </mat-form-field>

  @if (lotteryLicenseFormGroup.controls.lotteryLicense.value) {
    <mat-form-field class="full-width">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="Start date" formControlName="startDate" data-testid="date-range-report-start-date-input">
        <input matEndDate placeholder="End date" formControlName="endDate" data-testid="date-range-report-end-date-input">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker" data-testid="date-range-report-datepicker-toggle"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
      <mat-error>Date Range is required</mat-error>
    </mat-form-field>
  }
  </form>

  <div class="text-end">
    <button mat-raised-button (click)="onSubmit()" class="margin-top-med" data-testid="lottery-license-report-generate-button">Generate Reports</button>
  </div>

  @if (showReports) {
    <div class="margin-top-large">
      <app-lottery-license-report [reportingDataSetter]="reportingData"></app-lottery-license-report>
    </div>
  }
}
